import { Vue, Component, Watch } from 'vue-property-decorator'
import DocumentList from '@/components/dashboard/document/document-list/DocumentList.component.vue'
import DocumentFilter from '@/components/dashboard/document/document-filter/DocumentFilter.component.vue'
import DocumentDetail from '@/components/dashboard/document/document-detail/DocumentDetail.component.vue'
import { Document, TableHeader } from '@/types'
import Axios from 'axios'
import * as R from 'ramda'

@Component({
  components: {
    DocumentList,
    DocumentFilter,
    DocumentDetail
  }
})
export default class DocumentPageComponent extends Vue {
  // #region data
  items: Document[] = []
  page: number = 1
  totalPage: number = 1
  toggleFilter: boolean = false
  loadingData: boolean = false
  dataFilter: Object = {}
  options:boolean = false
  currentDocument:Document = {}
  loading: boolean = false
  toggleDetail: boolean = false
  documentDetails: DocumentDetail[] = []
  toggleErrorMessage:boolean = false
  itemsTotals = []
  headerTotals: TableHeader[] = [
    {
      text: 'Total General',
      value: 'title',
      sortable: false
    },
    {
      text: 'Grabado',
      value: 'taxedAmount',
      sortable: false
    },
    {
      text: 'Exonerado',
      value: 'exoneratedAmount',
      sortable: false
    },
    {
      text: 'I.G.V.',
      value: 'taxAmount',
      sortable: false
    },
    {
      text: 'Total',
      value: 'totalAmount',
      sortable: false
    }
  ]
  // #endregion

  @Watch('page')
  onChangePage (value:number, valueOld:number) {
    this.onLoadDocuments(this.dataFilter)
  }

  mounted () {
    this.onLoadDocuments({
      page: this.page,
      from: new Date().toISOString().substr(0, 10),
      to: new Date().toISOString().substr(0, 10)
    })
  }

  // #region methods
  onLoadDocuments (data: Object) {
    this.loadingData = true
    Axios.get('/documents', {
      params: {
        ...data,
        page: this.page
      }
    }).then(response => {
      this.itemsTotals = response.data.summary
      this.items = response.data.page.data
      this.totalPage = response.data.page.last_page
      this.loadingData = false
    }).catch(() => {
      this.loadingData = false
    })
  }

  onFilter (data:Object) {
    this.dataFilter = data
    this.onLoadDocuments(this.dataFilter)
  }
  // #endregion

  onDetailOptions (item: Document) {
    this.options = true
    this.currentDocument = item
  }

  printPDF () {
    if (R.equals(this.currentDocument.state, '0')) {
      this.options = false
      this.toggleErrorMessage = true
      return
    }

    this.options = false
    this.loading = true

    Axios.get('/documents/print-pdf', {
      responseType: 'arraybuffer',
      params: {
        voucherType: this.currentDocument.voucherType,
        voucherSerie: this.currentDocument.serieNumber,
        totalAmount: this.currentDocument.totalAmount,
        voucherNumber: this.currentDocument.documentNumber,
        dateIssue: this.currentDocument.dateIssue
      }
    }).then(response => {
      this.loading = false
      const blob = new Blob([response.data], { type: 'application/pdf' })
      open(URL.createObjectURL(blob))
    }).catch(() => {
      this.loading = false
    })
  }

  viewDetail () {
    this.loading = true
    Axios.get('/documents/detail', {
      params: {
        voucherType: this.currentDocument.voucherType,
        voucherSerie: this.currentDocument.serieNumber,
        totalAmount: this.currentDocument.totalAmount,
        voucherNumber: this.currentDocument.documentNumber,
        dateIssue: this.currentDocument.dateIssue
      }
    }).then(response => {
      this.toggleDetail = true
      this.loading = false
      this.documentDetails = response.data
    }).catch(() => {
      this.loading = false
      this.toggleDetail = false
    })
    this.options = false
  }
}
